import {
  BrokeredOrderSortOption,
  BrokeredOrderStatus,
  enumBrokeredOrderSortOption,
} from '@rematter/frontend-lib-api-client';
import { DataGridSelection } from '@rematter/ui-web';
import { atom } from 'jotai';

import { brokeredOrderCloseAtom } from '../_graphql/mutationBrokeredOrderClose';
import { brokeredOrderDeleteAtom } from '../_graphql/mutationBrokeredOrderDelete';
import { brokeredOrderOpenAtom } from '../_graphql/mutationBrokeredOrderOpen';
import { brokeredOrderVoidAtom } from '../_graphql/mutationBrokeredOrderVoid';
import { brokeredOrdersListQueryAtom } from '../_graphql/queryBrokeredOrdersList';
import { BrokeredOrderRecord } from '../types/brokeredOrder';

import { atomFromQueryString } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $searchTerm = atomFromQueryString.string('q');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);
export const $selectedSupplierIds =
  atomFromQueryString.stringSet('supplierIds');
export const $selectedCustomerIds =
  atomFromQueryString.stringSet('customerIds');
export const $selectedStatuses =
  atomFromQueryString.stringSet<BrokeredOrderStatus>('statuses');

// 🔘🔘🔘 PLAIN ATOMS
export const $selectedKeys = atom<DataGridSelection>(new Set<React.Key>());
export const $isCreateDialogOpen = atom<boolean>(false);
export const $selectedOrder = atom<BrokeredOrderRecord | null>(null);
export const $isVoidDialogOpen = atom<boolean>(false);
export const $isMarkAsFinishedDialogOpen = atom<boolean>(false);
export const $currentSorting = atom<BrokeredOrderSortOption[]>([
  enumBrokeredOrderSortOption.CreatedAtDesc,
]);

// 🟢🟢🟢 REMOTE DATA -> brokered orders list
export const $remoteBrokeredOrders = brokeredOrdersListQueryAtom((get) => {
  const searchTerm = get($searchTerm);
  const limit = get($limit);
  const offset = get($offset);
  const supplierIds = Array.from(get($selectedSupplierIds));
  const customerIds = Array.from(get($selectedCustomerIds));
  const statuses = Array.from(get($selectedStatuses));
  const sorting = get($currentSorting);

  return {
    variables: {
      searchTerm: searchTerm || undefined,
      supplierIds: supplierIds.length > 0 ? supplierIds : undefined,
      customerIds: customerIds.length > 0 ? customerIds : undefined,
      statuses: statuses.length > 0 ? statuses : undefined,
      limit,
      offset,
      sorting,
    },
  };
});

// 🟠🟠🟠 ACTION -> delete brokered order
export const $deleteBrokeredOrder = brokeredOrderDeleteAtom({
  onSuccess: (get) => {
    get($remoteBrokeredOrders).refetch?.();
  },
});

// 🟠🟠🟠 ACTION -> void brokered order
export const $voidBrokeredOrder = brokeredOrderVoidAtom({
  onSuccess: (get) => {
    get($remoteBrokeredOrders).refetch?.();
  },
});

// 🟠🟠🟠 ACTION -> open brokered order
export const $openBrokeredOrder = brokeredOrderOpenAtom({
  onSuccess: (get) => {
    get($remoteBrokeredOrders).refetch?.();
  },
});

// 🟠🟠🟠 ACTION -> close brokered order (mark as finished)
export const $closeBrokeredOrder = brokeredOrderCloseAtom({
  onSuccess: (get) => {
    get($remoteBrokeredOrders).refetch?.();
  },
});
